import React, { useState, useEffect, Fragment, useRef } from 'react';
import { useAlert } from 'react-alert';
import {
  Box,
  Card,
  Grid,
  TextField,
  makeStyles,
  Container,
  Button,
  CardContent,
  Divider,
  InputLabel,
  CardHeader,
  MenuItem,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow
} from '@material-ui/core';
import Page from 'src/components/Page';
import services from '../Services';
import { trackPromise } from 'react-promise-tracker';
import { Formik } from 'formik';
import * as Yup from 'yup';
import authService from '../../../../utils/permissionAuth';
import tokenService from '../../../../utils/tokenDecoder';
import {
  DatePicker,
  MuiPickersUtilsProvider
} from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import { useNavigate } from 'react-router-dom';
import moment from 'moment';
import xlsx from 'json-as-xlsx';
import ReactToPrint from 'react-to-print';
import CreatePDF from './CreatePDF';

const useStyles = makeStyles(theme => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    minHeight: '100%',
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3)
  },
  avatar: {
    marginRight: theme.spacing(2)
  },
  colorCancel: {
    backgroundColor: 'red'
  },
  colorRecord: {
    backgroundColor: 'green'
  }
}));

const screenCode = 'TC15SUMMARYREPORT';

export default function TcSummaryReport(props) {
  const [title, setTitle] = useState('TC 15 Summary Report');
  const classes = useStyles();
  const [GroupList, setGroupList] = useState([]);
  const [FactoryList, setFactoryList] = useState([]);
  const [routes, setRoutes] = useState();
  const [supplierCropdetails, setSupplierCropdetails] = useState({
    groupID: 0,
    factoryID: 0,
    routeID: 0,
    year: '',
    month: ''
  });
  const [supplierCropData, setSupplierCropData] = useState([]);
  const [totalGrosWeight, settotalGrosWeight] = useState([]);
  const [totalDayCount, setDayCount] = useState([]);
  const [totalAvarage, setAvarage] = useState([]);
  const [Uniquedates, setUniquedates] = useState([]);
  const [permissionList, setPermissions] = useState({
    isGroupFilterEnabled: false,
    isFactoryFilterEnabled: false
  });
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [selectedSearchValues, setSelectedSearchValues] = useState({
    monthName: '',
    factoryName: '0',
    routeName: '0',
    groupName: '0'
  });
  const navigate = useNavigate();
  const alert = useAlert();
  const componentRef = useRef();
  const [isViewTable, setIsViewTable] = useState(true);

  useEffect(() => {
    trackPromise(getPermission());
    trackPromise(getGroupsForDropdown());
  }, []);

  useEffect(() => {
    trackPromise(getFactoriesForDropdown());
    setIsViewTable(true);
  }, [supplierCropdetails.groupID]);

  useEffect(() => {
    trackPromise(getRoutesByFactoryID());
    setIsViewTable(true);
  }, [supplierCropdetails.factoryID]);

  useEffect(() => {
    setIsViewTable(true);
  }, [supplierCropdetails.routeID]);

  useEffect(() => {
    setIsViewTable(true);
  }, [supplierCropdetails.month]);

  async function getPermission() {
    var permissions = await authService.getPermissionsByScreen(screenCode);
    var isAuthorized = permissions.find(
      p => p.permissionCode == 'TC15SUMMARYREPORT'
    );

    if (isAuthorized === undefined) {
      navigate('/404');
    }
    var isGroupFilterEnabled = permissions.find(
      p => p.permissionCode == 'GROUPDROPDOWN'
    );
    var isFactoryFilterEnabled = permissions.find(
      p => p.permissionCode == 'FACTORYDROPDOWN'
    );

    setPermissions({
      ...permissionList,
      isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
      isFactoryFilterEnabled: isFactoryFilterEnabled !== undefined
    });

    setSupplierCropdetails({
      ...supplierCropdetails,
      groupID: parseInt(tokenService.getGroupIDFromToken()),
      factoryID: parseInt(tokenService.getFactoryIDFromToken())
    });
  }

  async function getGroupsForDropdown() {
    const groups = await services.getAllGroups();
    setGroupList(groups);
  }

  async function getFactoriesForDropdown() {
    const factories = await services.getFactoryByGroupID(
      supplierCropdetails.groupID
    );
    setFactoryList(factories);
  }

  async function getRoutesByFactoryID() {
    const routeList = await services.getRoutesForDropDown(
      supplierCropdetails.factoryID
    );
    setRoutes(routeList);
  }

  async function GetCropDetails() {
    let model = {
      groupID: parseInt(supplierCropdetails.groupID),
      factoryID: parseInt(supplierCropdetails.factoryID),
      routeID: parseInt(supplierCropdetails.routeID),
      applicableMonth:
        supplierCropdetails.month === ''
          ? moment(new Date()).format('MM')
          : supplierCropdetails.month,
      applicableYear:
        supplierCropdetails.year === ''
          ? moment(new Date()).format('YYYY')
          : supplierCropdetails.year
    };

    getSelectedDropdownValuesForReport(model);
    const cropData = await services.GetSummaryDeatailsMonthlyCrop(model);
    if (cropData.statusCode === 'Success' && cropData.data != null) {
      setIsViewTable(false);


      cropData.data.forEach(x => {
        let total = 0;
        x.details.forEach(y => {
          total += y.netWeight;
          x.totalWeight = total;
        });
      });

      cropData.data.forEach(x => {
        x.dayCount = x.details.length;
      });

      const extractDetails = (obj) => {
        let result = [];
        Object.keys(obj).forEach(key => {
          const value = obj[key];
          if (key === 'details' && Array.isArray(value)) {
            value.forEach(item => result.push(item));
          } else if (typeof value === 'object' && value !== null) {
            result = result.concat(extractDetails(value));
          }
        });
        return result;
      };

      const allDetails = extractDetails(cropData);
      const Uniquedates = Object.keys(allDetails.reduce((r, { cropCollectedDate }) => (r[cropCollectedDate] = '', r), {}));

      const totalnetWeight = cropData.data.reduce((accumulator, current) => accumulator + current.totalWeight, 0);
      const averageBasedOnUniqueDates = totalnetWeight / Uniquedates.length;
      cropData.data.forEach(x => {
        if (Uniquedates.length > 0) {
          x.average = x.totalWeight / x.dayCount;
        } else {
          x.average = 0;
        }
      });

      settotalGrosWeight(totalnetWeight);
      setDayCount(Uniquedates.length);
      setAvarage(averageBasedOnUniqueDates);
      setSupplierCropData(cropData.data);
      setUniquedates(Uniquedates);

      if (cropData.data.length === 0) {
        setIsViewTable(true);
        alert.error('No records to display');
      }
    } else {
      alert.error(cropData.message);
    }
  }

  function generateDropDownMenu(data) {
    let items = [];
    if (data != null) {
      for (const [key, value] of Object.entries(data)) {
        items.push(
          <MenuItem key={key} value={key}>
            {value}
          </MenuItem>
        );
      }
    }
    return items;
  }

  function handleChange(e) {
    const target = e.target;
    const value = target.value;
    setSupplierCropdetails({
      ...supplierCropdetails,
      [e.target.name]: value
    });
    setSupplierCropData([]);
  }

  function handleDateChange(date) {
    let monthNames = [
      'JAN',
      'FEB',
      'MARCH',
      'APRIL',
      'MAY',
      'JUNE',
      'JULY',
      'AUG',
      'SEPT',
      'OCT',
      'NOV',
      'DEC'
    ];
    var month = date.getUTCMonth() + 1;
    var year = date.getUTCFullYear();
    let monthName = monthNames[month - 1];
    setSelectedSearchValues({
      ...selectedSearchValues,
      monthName: monthName
    });
    setSupplierCropdetails({
      ...supplierCropdetails,
      month: month.toString(),
      year: year.toString()
    });

    if (selectedDate != null) {
      var prevMonth = selectedDate.getUTCMonth() + 1;
      var prevyear = selectedDate.getUTCFullYear();

      if ((prevyear == year && prevMonth != month) || prevyear != year) {
        setSelectedDate(date);
      }
    } else {
      setSelectedDate(date);
    }
    setSupplierCropData([]);
  }

  async function createDataForExcel(array) {
    if (array != null) {
      var result = [];
      var dayTotals = {};
      var totalAmountSum = 0;
      dayTotals.routeName = 'Total';
      dayTotals.totalWeight = 0;
      dayTotals.dayCount = 0;
      dayTotals.average = 0;
      for (let day = 1; day <= 31; day++) {
        dayTotals[`day${day}`] = 0;
      }

      array.forEach(x => {
        x.details.forEach(y => {
          const day = moment(y.cropCollectedDate).format('D');
          var duplicateDate = result.find(y => y.routeName === x.routeName);

          if (duplicateDate) {
            duplicateDate[`day${day}`] = y.netWeight ? y.netWeight.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : "-";
            duplicateDate.routeName = x.routeName;
            duplicateDate.totalWeight = x.totalWeight ? x.totalWeight.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : "-";
            duplicateDate.dayCount = x.dayCount;
            duplicateDate.average = x.average.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
          } else {
            let entry = {
              routeName: x.routeName,
              totalWeight: x.totalWeight.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
              dayCount: x.dayCount,
              average: x.average.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
            };
            entry[`day${day}`] = y.netWeight ? y.netWeight.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : "-";
            result.push(entry);
          }

          dayTotals[`day${day}`] = (dayTotals[`day${day}`] || 0) + y.netWeight;
          totalAmountSum += y.netWeight;
          dayTotals.totalWeight = totalAmountSum.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
          dayTotals.dayCount = Uniquedates.length;
          dayTotals.average = totalAvarage.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
        });
      });

      result.push(dayTotals);
      result.push({});

      result.push({});
      var vr = {
        routeName: "Group:" + selectedSearchValues.groupName,
        totalWeight: "Factory:" + selectedSearchValues.factoryName,

      }
      result.push(vr);

      var vr = {
        routeName: "Route: " + (selectedSearchValues.routeName ? selectedSearchValues.routeName : 'All Routes'),
        totalWeight: "Date: " + selectedDate.toLocaleDateString('en-US', { month: 'short', year: 'numeric' }),
      };
      result.push(vr);
    }
    return result;
  }

  async function createFile() {
    let tempcsvHeaders = [];

    var file = await createDataForExcel(supplierCropData);
    var settings = {
      RTL: false,
      sheetName: 'TC 15 Summary Report',
      fileName: 'TC 15 Summary Report' + ' - ' + selectedSearchValues.groupName + ' - '
        + selectedSearchValues.factoryName + ' - ' +
        (selectedSearchValues.routeName ? selectedSearchValues.routeName : 'All Routes') + ' - ' +
        (selectedDate.toLocaleDateString('en-US', { month: 'short', year: 'numeric' })),
      writeOptions: {}
    };
    tempcsvHeaders.push({ label: 'Route Name', value: 'routeName' });
    tempcsvHeaders.push({ label: 'Total Weight (KG)', value: 'totalWeight' });
    for (let day = 1; day <= 31; day++) {
      tempcsvHeaders.push({ label: `Day ${day}`, value: `day${day}` });
    }
    tempcsvHeaders.push({ label: 'Crop Date', value: 'dayCount' });
    tempcsvHeaders.push({ label: 'Average', value: 'average' });
    let dataA = [
      {
        sheet: 'TC 15 Summary Report',
        columns: tempcsvHeaders,
        content: file
      }
    ];

    xlsx(dataA, settings);
  }

  function getSelectedDropdownValuesForReport(searchForm) {
    setSelectedSearchValues({
      ...selectedSearchValues,
      factoryName: FactoryList[searchForm.factoryID],
      routeName: routes[searchForm.routeID],
      year: searchForm.year,
      groupName: GroupList[searchForm.groupID]
    });
  }

  const getPageMargins = () => {
    return `@media print {
        @page {
            size: A3 Landscape !important;
            margin: 50px 24px 56px 24px !important;
            background-color: white !important;
        }
        body {
            transform: scale(1, 1);
            transform-origin: top left;
            background-color: white !important;
            width: 100%;
        }
    }`;
  };

  function cardTitle(titleName) {
    return (
      <Grid container spacing={1}>
        <Grid item md={10} xs={12}>
          {titleName}
        </Grid>
      </Grid>
    );
  }

  const daysArray = Array.from({ length: 31 }, (_, index) => index + 1);
  return (
    <Fragment>
      <Page className={classes.root} title={title}>
        <Container maxWidth={false}>
          <Formik
            initialValues={{
              groupID: supplierCropdetails.groupID,
              factoryID: supplierCropdetails.factoryID,
              routeID: supplierCropdetails.routeID
            }}
            validationSchema={Yup.object().shape({
              groupID: Yup.number()
                .required('Group is required')
                .min('1', 'Group is required'),
              factoryID: Yup.number()
                .required('Factory is required')
                .min('1', 'Factory is required')

            })}
            onSubmit={() => trackPromise(GetCropDetails())}
            enableReinitialize
          >
            {({ errors, handleBlur, handleSubmit, touched }) => (
              <form onSubmit={handleSubmit}>
                <Box mt={0}>
                  <Card>
                    <CardHeader title={cardTitle(title)} />
                    <Divider />
                    <CardContent>
                      <Grid container spacing={3}>
                        <Grid item md={3} xs={12}>
                          <InputLabel shrink id="groupID">
                            Group *
                          </InputLabel>
                          <TextField
                            select
                            error={Boolean(touched.groupID && errors.groupID)}
                            fullWidth
                            helperText={touched.groupID && errors.groupID}
                            name="groupID"
                            onBlur={handleBlur}
                            onChange={e => handleChange(e)}
                            value={supplierCropdetails.groupID}
                            variant="outlined"
                            id="groupID"
                            size="small"
                            disabled={!permissionList.isGroupFilterEnabled}
                          >
                            <MenuItem value="0">--Select Group--</MenuItem>
                            {generateDropDownMenu(GroupList)}
                          </TextField>
                        </Grid>
                        <Grid item md={3} xs={12}>
                          <InputLabel shrink id="factoryID">
                            Factory *
                          </InputLabel>
                          <TextField
                            select
                            error={Boolean(
                              touched.factoryID && errors.factoryID
                            )}
                            fullWidth
                            helperText={touched.factoryID && errors.factoryID}
                            name="factoryID"
                            onBlur={handleBlur}
                            onChange={e => handleChange(e)}
                            value={supplierCropdetails.factoryID}
                            variant="outlined"
                            id="factoryID"
                            size="small"
                            disabled={!permissionList.isFactoryFilterEnabled}
                          >
                            <MenuItem value="0">--Select Factory--</MenuItem>
                            {generateDropDownMenu(FactoryList)}
                          </TextField>
                        </Grid>
                        <Grid item md={3} xs={12}>
                          <InputLabel shrink id="routeID">
                            Route
                          </InputLabel>
                          <TextField
                            select
                            error={Boolean(touched.routeID && errors.routeID)}
                            fullWidth
                            helperText={touched.routeID && errors.routeID}
                            name="routeID"
                            onChange={e => handleChange(e)}
                            value={supplierCropdetails.routeID}
                            variant="outlined"
                            id="routeID"
                            size="small"
                          >
                            <MenuItem value="0">--Select Route--</MenuItem>
                            {generateDropDownMenu(routes)}
                          </TextField>
                        </Grid>
                        <Grid item md={3} xs={12}>
                          <MuiPickersUtilsProvider utils={DateFnsUtils}>
                            <DatePicker
                              autoOk
                              variant="inline"
                              openTo="month"
                              views={['year', 'month']}
                              label="Year and Month *"
                              helperText="Select applicable month"
                              value={selectedDate}
                              onChange={date => handleDateChange(date)}
                            />
                          </MuiPickersUtilsProvider>
                        </Grid>
                      </Grid>
                      <Box display="flex" flexDirection="row-reverse" p={2}>
                        <Button
                          color="primary"
                          type="submit"
                          variant="contained"
                          size="small"
                        >
                          Search
                        </Button>
                      </Box>
                      <Box minWidth={1000} hidden={isViewTable}>
                        {/* {supplierCropData.length > 0 ? ( */}
                        <TableContainer style={{ maxHeight: '550px', overflowY: 'auto' }}>
                          <Table style={{ width: '100%' }} size="small" aria-label="simple table">
                            <TableHead>
                              <TableRow>
                                <TableCell style={{ border: "1px solid black", fontWeight: "bold", fontSize: "16px" }} align="center">
                                  Route
                                </TableCell>
                                <TableCell style={{ border: "1px solid black", fontWeight: "bold", fontSize: "16px" }} align="center">
                                  Total Weight (KG)
                                </TableCell>
                                {daysArray.sort((a, b) => new Date(a) - new Date(b)).map((day, index) => {
                                  return (
                                    <TableCell style={{ border: "1px solid black", fontWeight: "bold", fontSize: "16px" }} align="center">
                                      {day}
                                    </TableCell>
                                  );
                                })}
                                <TableCell style={{ border: "1px solid black", fontWeight: "bold", fontSize: "16px" }} align="center">
                                  Crop Date
                                </TableCell>
                                <TableCell style={{ border: "1px solid black", fontWeight: "bold", fontSize: "16px" }} align="center">
                                  Avarage
                                </TableCell>
                              </TableRow>
                            </TableHead>
                            <TableBody>
                              {supplierCropData.map((row, index) => {
                                return (
                                  <TableRow key={index}>
                                    <TableCell style={{ border: "1px solid black" }} align="left" component="th" scope="row">
                                      {row.routeName}
                                    </TableCell>
                                    <TableCell style={{ border: "1px solid black" }} align="right" component="th" scope="row">
                                      {row.totalWeight.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                    </TableCell>
                                    {daysArray.sort((a, b) => new Date(a) - new Date(b)).map((day, index) => {
                                      var found = row.details.find(x => moment(x.cropCollectedDate).format('DD') == day);
                                      return (
                                        <TableCell style={{ border: "1px solid black", padding: '4px' }} align={found == undefined ? "center" : "right"}>
                                          {found == undefined ? '-' : found.netWeight.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                        </TableCell>
                                      );
                                    }
                                    )}
                                    <TableCell style={{ border: "1px solid black", fontWeight: "bold", alignContent: "left" }} align="right" component="th" scope="row">
                                      {row.dayCount}
                                    </TableCell>
                                    <TableCell style={{ border: "1px solid black", fontWeight: "bold", alignContent: "left" }} align="right" component="th" scope="row">
                                      {row.average.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                    </TableCell>
                                  </TableRow>
                                );
                              })}
                              <TableRow>
                                <TableCell style={{ border: "1px solid black", fontWeight: "bold", fontSize: "16px" }} align="center">
                                  Total
                                </TableCell>
                                <TableCell style={{ border: "1px solid black", fontWeight: "bold", fontSize: "16px" }} align="center">
                                  {totalGrosWeight.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                </TableCell>
                                {daysArray.sort((a, b) => new Date(a) - new Date(b)).map((day, index) => {
                                  const dayTotal = supplierCropData.reduce((total, row) => {
                                    const found = row.details.find(x => moment(x.cropCollectedDate).format('DD') == day);
                                    return total + (found ? parseFloat(found.netWeight) : 0);
                                  }, 0);
                                  return (
                                    <TableCell style={{ border: "1px solid black", fontWeight: "bold" }} align={dayTotal !== 0 ? "right" : "center"}>
                                      {dayTotal !== 0 ? dayTotal.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : '-'}
                                    </TableCell>
                                  );
                                })}
                                <TableCell style={{ border: "1px solid black", fontWeight: "bold" }} align="right">
                                  {Uniquedates.length}
                                </TableCell>
                                <TableCell style={{ border: "1px solid black", fontWeight: "bold" }} align="right">
                                  {totalAvarage.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                </TableCell>
                              </TableRow>
                            </TableBody>
                          </Table>
                        </TableContainer>
                        {/* ) : null} */}
                      </Box>
                    </CardContent>
                    <br />
                    <Divider />
                    {supplierCropData.length > 0 ? (
                      <Box display="flex" justifyContent="flex-end" p={2}>
                        <Button
                          color="primary"
                          id="btnRecord"
                          type="submit"
                          variant="contained"
                          style={{ marginRight: '1rem' }}
                          className={classes.colorRecord}
                          onClick={() => createFile()}
                          size="small"
                        >
                          EXCEL
                        </Button>
                        <ReactToPrint
                          documentTitle={
                            'TC 15 Summary Report' + ' - ' + selectedSearchValues.groupName + ' - ' + selectedSearchValues.factoryName + ' - ' + (selectedSearchValues.routeName ? selectedSearchValues.routeName : 'All Routes') + ' - ' +
                            (selectedDate.toLocaleDateString('en-US', { month: 'short', year: 'numeric' }))
                          }
                          trigger={() => (
                            <Button
                              color="primary"
                              id="btnRecord"
                              variant="contained"
                              style={{ marginRight: '1rem' }}
                              className={classes.colorCancel}
                              size="small"
                            >
                              PDF
                            </Button>
                          )}
                          pageStyle={getPageMargins()}
                          content={() => componentRef.current}
                        />
                        <div hidden={true}>
                          <CreatePDF
                            ref={componentRef}
                            supplierCropData={supplierCropData}
                            totalDayCount={totalDayCount}
                            totalAvarage={totalAvarage}
                            daysArray={daysArray}
                            totalGrosWeight={totalGrosWeight}
                            selectedSearchValues={selectedSearchValues}
                            searchDate={supplierCropdetails}
                            selectedDate={selectedDate}
                            Uniquedates={Uniquedates}
                          />
                        </div>
                      </Box>

                    ) : null}
                  </Card>
                </Box>
              </form>
            )}
          </Formik>
        </Container>
      </Page>
    </Fragment>
  );
}
